import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { ILastPaymentResponse } from '../models/PaymentModel'

export class GetLastSuccessPaymentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/getLastSuccessPayment',
      requesterInfo,
    })
  }

  public async getLast(): Promise<ILastPaymentResponse> {
    return await this.getAsync<ILastPaymentResponse>()
  }
}
